define('viewmodels/secured/explorer/details/DocumentClipboard',[], function () {

    var documentInfoList = ko.observableArray();
    var mode = ko.observable(); // readonly

    var clipboard = {
        modes: {
            copy: "copy",
            cut: "cut"
        },
        mode: ko.computed(function () {
            return mode();
        })
    };

    clipboard.toDocumentLocationList = function(documentInfoList) {
        return _.map(documentInfoList, function (documentInfo) {
            return {
                documentId: documentInfo.documentId,
                folderId: documentInfo.folderId
            };
        });
    };

    clipboard.toDocumentIdList = function (documentInfoList) {
        return _.map(documentInfoList, function (documentInfo) {
            return {
                documentId: documentInfo.documentId
            };
        });
    };

    clipboard.cut = function(documentInfos) {
        if (!documentInfos)
            return;

        if (!_.isArray(documentInfos))
            documentInfos = [documentInfos];

        documentInfoList(documentInfos);
        mode(clipboard.modes.cut);
    };

    clipboard.copy = function (documentInfos) {
        if (!documentInfos)
            return;

        if (!_.isArray(documentInfos))
            documentInfos = [documentInfos];

        documentInfoList(documentInfos);
        mode(clipboard.modes.copy);
    };

    clipboard.paste = function () {
        var documents = documentInfoList();
        if (clipboard.mode() == clipboard.modes.cut) {
            clipboard.clear();
        }
        return documents;
    };

    clipboard.clear = function () {
        mode(null);
        documentInfoList([]);
    };

    clipboard.isEmpty = ko.computed(function() {
        return !documentInfoList().length;
    });

    clipboard.canCopy = ko.computed(function () {
        var mode = clipboard.mode();
        return !clipboard.isEmpty() && mode == clipboard.modes.copy;
    });

    clipboard.canMove = ko.computed(function () {
        var mode = clipboard.mode();
        return !clipboard.isEmpty() && mode == clipboard.modes.cut;
    });

    return clipboard;

});
